import { mergePagedResults, PagedResult } from '../utils/paged-results';

export const mergeSessions = <T extends { sessionId: string; date: string }>(
    currentData: PagedResult<T> | undefined,
    newData: PagedResult<T> & {
        offset?: number;
        pageSize?: number;
    },
): PagedResult<T> => {
    return mergePagedResults(currentData, newData, {
        equals: (a, b) => a.sessionId === b.sessionId,
        sort: (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
        removeMissing:
            // only comparing data from server
            typeof currentData?.totalCount === 'number' &&
            typeof newData.totalCount === 'number' &&
            // let's do it only for fetching first page of sessions, otehrwise it's too complicated
            newData.offset === 0,
    });
};
